import axios from "axios";
import { initializeApp } from "firebase/app";
import {
    connectAuthEmulator,
    getAuth,
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithPopup,
    signOut as firebaseSignOut,
} from "firebase/auth";

const app = initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

export const auth = getAuth(app);

// E2E tests only (e2e/): sign in against the Firebase Auth emulator. Never set in CI or deploy builds.
if (process.env.REACT_APP_FIREBASE_AUTH_EMULATOR) {
    connectAuthEmulator(auth, process.env.REACT_APP_FIREBASE_AUTH_EMULATOR, { disableWarnings: true });
}

export const signInWithGoogle = () => signInWithPopup(auth, new GoogleAuthProvider());

export const signOut = () => firebaseSignOut(auth);

export const onAuthChange = callback => onAuthStateChanged(auth, callback);

// Popup closed or replaced by the user: not an error worth showing.
export const isCancelledSignIn = error =>
    error?.code === "auth/popup-closed-by-user" || error?.code === "auth/cancelled-popup-request";

export async function addBearer(config) {
    const user = auth.currentUser;
    if (user) {
        const token = await user.getIdToken();
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
}

axios.interceptors.request.use(addBearer);

// Sentry hooks: drop any Authorization value wherever it sits in a breadcrumb or an event.
export function stripAuthorization(value, seen = new WeakSet()) {
    if (value && typeof value === "object" && !seen.has(value)) {
        seen.add(value);
        for (const key of Object.keys(value)) {
            if (key.toLowerCase() === "authorization") {
                delete value[key];
            } else {
                stripAuthorization(value[key], seen);
            }
        }
    }
    return value;
}

export const beforeBreadcrumb = breadcrumb => stripAuthorization(breadcrumb);
export const beforeSend = event => stripAuthorization(event);
